import {
    MENU_IMPORT_QUOTA_EXHAUSTED,
    MENU_IMPORT_QUOTA_LOADING,
    MENU_IMPORT_QUOTA_OF,
    MENU_IMPORT_QUOTA_RESETS,
    MENU_IMPORT_QUOTA_THIS_MONTH,
    MENU_IMPORT_QUOTA_UNAVAILABLE,
} from '../../../../../../constants/strings';
import { JTranslation } from '../../../../../../helpers/jTranslationHelper';
import { _OrgImportQuota, _QuotaLevel, formatUtcDate, getQuotaLevel } from '../../../../../../helpers/menuImportHelper';

type Props = {
    quota: _OrgImportQuota | null;
    isLoading?: boolean;
    isError?: boolean;
};

const LEVEL_ICON: Record<_QuotaLevel, string> = {
    ok: 'ri-checkbox-circle-line',
    low: 'ri-error-warning-line',
    exhausted: 'ri-close-circle-line',
};

/** The monthly import allowance (the organization's; venues have no quota of their own), coloured by how much is left. */
const QuotaSummary = ({ quota, isLoading, isError }: Props) => {
    if (!quota) {
        const text = isLoading ? MENU_IMPORT_QUOTA_LOADING : isError ? MENU_IMPORT_QUOTA_UNAVAILABLE : undefined;
        return text ? (
            <div className="bulk-upload-quota muted" data-testid="import-quota" role="status">
                <JTranslation text={text} typeCase="capitalize" />
            </div>
        ) : null;
    }

    const level = getQuotaLevel(quota.remaining, quota.limit);
    const barMax = Math.max(quota.limit, 1);
    const barValue = quota.limit > 0 ? Math.min(quota.used, quota.limit) : barMax;
    return (
        <div className={`bulk-upload-quota ${level}`} data-testid="import-quota" role="status">
            <i className={LEVEL_ICON[level]} aria-hidden="true" />
            <span>
                <JTranslation text={MENU_IMPORT_QUOTA_THIS_MONTH} typeCase="capitalize" /> <strong>{quota.used}</strong>{' '}
                <JTranslation text={MENU_IMPORT_QUOTA_OF} typeCase="none" /> <strong>{quota.limit}</strong> ·{' '}
                <JTranslation text={MENU_IMPORT_QUOTA_RESETS} typeCase="none" /> {formatUtcDate(quota.resetsAt)}
            </span>
            <progress className="bulk-upload-quota-bar" aria-hidden="true" data-testid="import-quota-bar" max={barMax} value={barValue} />
            {level === 'exhausted' && (
                <span className="bulk-upload-quota-message">
                    <JTranslation text={MENU_IMPORT_QUOTA_EXHAUSTED} typeCase="capitalize" />
                </span>
            )}
        </div>
    );
};

export default QuotaSummary;
